module.exports = __webpack_public_path__ + "static/media/10a.961123a1.jpg";